import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignOrderItemIdReducer = (state: DesignState, action: PayloadAction<number|undefined>) => {
  state.orderItemId = action.payload;
};

export default setDesignOrderItemIdReducer;
